import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

// When MSAL performs ssoSilent it opens a hidden iframe that navigates back to
// this app. Skip the full bootstrap in that case — MSAL handles the response
// internally and posts the token back to the parent frame.
const isInMsalIframe = window !== window.parent && !window.opener;

if (!isInMsalIframe) {
  bootstrapApplication(AppComponent, appConfig).catch((err) =>
    console.error(err)
  );
}
